import { useContext, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { getReportsDropdown } from '../apiCalls';
import { Input, Select } from '../Input/Input';
import { StoreContext } from '../Store';

export default function ReportsAdmin() {
  const store = useContext(StoreContext);
  const navigate = useNavigate();

  const { reportName } = useParams();

  const handleSubmit = (event) => {
    event.preventDefault();
    const reportEndPoint = store.reportParams[0][0]?.endPoint;

    if (
      store.reportCreatedStartDate[0] == '' &&
      store.reportCompletedStartDate[0] !== '' &&
      store.reportCustomer[0] == ''
    ) {
      navigate(
        `/ReportsResults/${reportEndPoint}/${reportName}/1/${store.reportCompletedStartDate[0]}/${store.reportCompletedEndDate[0]}`
      );
      return;
    }
    if (
      store.reportCompletedStartDate[0] == '' &&
      store.reportCreatedStartDate[0] !== '' &&
      store.reportCustomer[0] == ''
    ) {
      navigate(
        `/ReportsResults/${reportEndPoint}/${reportName}/2/${store.reportCreatedStartDate[0]}/${store.reportCreatedEndDate[0]}`
      );
      return;
    }
    if (
      store.reportCompletedStartDate[0] !== '' &&
      store.reportCreatedStartDate[0] !== '' &&
      store.reportCustomer[0] == ''
    ) {
      navigate(
        `/ReportsResults/${reportEndPoint}/${reportName}/3/${store.reportCreatedStartDate[0]}/${store.reportCreatedEndDate[0]}/${store.reportCompletedStartDate[0]}/${store.reportCompletedEndDate[0]}`
      );
      return;
    }
    if (
      store.reportCreatedStartDate[0] == '' &&
      store.reportCompletedStartDate[0] !== '' &&
      store.reportCustomer[0] !== ''
    ) {
      navigate(
        `/ReportsResults/${reportEndPoint}/${reportName}/5/${store.reportCompletedStartDate[0]}/${store.reportCompletedEndDate[0]}/${store.reportCustomer[0]}`
      );
      return;
    }
    if (
      store.reportCompletedStartDate[0] == '' &&
      store.reportCreatedStartDate[0] !== '' &&
      store.reportCustomer[0] !== ''
    ) {
      navigate(
        `/ReportsResults/${reportEndPoint}/${reportName}/6/${store.reportCreatedStartDate[0]}/${store.reportCreatedEndDate[0]}/${store.reportCustomer[0]}`
      );
      return;
    }
    if (
      store.reportCompletedStartDate[0] !== '' &&
      store.reportCreatedStartDate[0] !== '' &&
      store.reportCustomer[0] !== ''
    ) {
      navigate(
        `/ReportsResults/${reportEndPoint}/${reportName}/7/${store.reportCreatedStartDate[0]}/${store.reportCreatedEndDate[0]}/${store.reportCompletedStartDate[0]}/${store.reportCompletedEndDate[0]}/${store.reportCustomer[0]}`
      );
      return;
    }
    if (
      store.reportCompletedStartDate[0] == '' &&
      store.reportCreatedStartDate[0] == '' &&
      store.reportCustomer[0] !== ''
    ) {
      navigate(`/ReportsResults/${reportEndPoint}/${reportName}/8/${store.reportCustomer[0]}`);
      return;
    } else {
      navigate(`/ReportsResults/${reportEndPoint}/${reportName}/4?viewDeleted=${store.reportViewDeleted[0]}`);
      return;
    }
  };

  const [disableCreatedDateInputs, setDisableCreatedDateInputs] = useState(true);
  const [disableCompletedDateInputs, setDisableCompletedDateInputs] = useState(true);
  const [disableDepInputs, setDisableDepInputs] = useState(true);
  const [disableUserInputs, setDisableUserInputs] = useState(true);
  const [disableCustInputs, setDisableCustInputs] = useState(true);
  const [enableCreated, setEnableCreated] = useState(false);
  const [enableCompleted, setEnableCompleted] = useState(false);
  const [enableDeleted, setEnableDeleted] = useState(false);
  const [customerCall, setCustomerCall] = useState(false);
  const [dropdownData, setDropdownData] = useState('');

  useEffect(() => {
    try {
      setDisableDepInputs(true);
      setDisableUserInputs(true);
      setDisableCreatedDateInputs(true);
      setDisableCompletedDateInputs(true);
      setEnableCompleted(false);
      setEnableCreated(false);
      setCustomerCall(false);
      setEnableDeleted(false);

      if (store.reportParams[0][0]?.parameters) {
        JSON.parse(store.reportParams[0][0]?.parameters).forEach((ddata) => {
          if (ddata.Type === 'Dropdown') {
            setDisableCustInputs(false);
            setCustomerCall(true);
            setDropdownData(ddata.data);
          }
          if (ddata.Type === 'Date') {
            if (ddata.data === 'Completed') {
              setDisableCompletedDateInputs(false);
              setEnableCompleted(true);
            }
            if (ddata.data === 'Created') {
              setDisableCreatedDateInputs(false);
              setEnableCreated(true);
            }
          }
          if (ddata.data === 'Include Deleted') {
            setEnableDeleted(true);
          }
        });
      }
    } catch (err) {
      console.log(err);
    }
  }, [store.reportParams[0]]);

  useEffect(() => {
    async function fetchData() {
      resetSelection(); //Reset route params on load
      if (customerCall === true) {
        const dropdownList = await getReportsDropdown(0, dropdownData.toLowerCase() + 'Dropdown');
        if (dropdownList) {
          store.reportCustomerDropdown[1](dropdownList);
        }
      }
    }
    fetchData();
  }, [customerCall]);

  const backToSelection = () => {
    resetSelection();
    navigate(`/ReportsList/`);
  };

  const resetSelection = () => {
    store.reportCreatedStartDate[1]('');
    store.reportCreatedEndDate[1]('');
    store.reportCompletedStartDate[1]('');
    store.reportCompletedEndDate[1]('');
    store.reportUser[1]('');
    store.reportCustomer[1]('');
  };

  const resultsEnableFinanceReporting = (completedStartDate, completedEndDate, selectedParent) => {
    return !completedEndDate || !completedStartDate || !selectedParent;
  };

  const isSubmitDisabled = () => {
    // Report must be selected
    if (store.reportSelected[0] === false) {
      return true;
    }

    if (store.reportParams[0]?.[0]?.['data'] == 'Finance Report - CABIE') {
      return resultsEnableFinanceReporting(
        store?.reportCompletedStartDate?.[0],
        store?.reportCompletedEndDate?.[0],
        store?.reportCustomer?.[0]
      );
    }

    // department input validation
    if (!disableDepInputs && store.reportDepartment[0] === '') {
      return true;
    }

    // user input validation
    if (!disableUserInputs && store.reportUser[0] === '') {
      return true;
    }

    // Helper function to check if one date is filled but not the other
    const hasPartialDateRange = (startDate, endDate) => {
      return (startDate === '' && endDate !== '') || (startDate !== '' && endDate === '');
    };

    // specific logic for liability report - button must be disabled until both dates are entered
    if (
      store.reportParams[0]?.[0]?.['data'] == 'Liability Report' &&
      !disableCreatedDateInputs &&
      (store.reportCreatedStartDate[0] === '' || store.reportCreatedEndDate[0] === '')
    ) {
      return true;
    }

    // Check created date range validation
    if (
      !disableCreatedDateInputs &&
      hasPartialDateRange(store.reportCreatedStartDate[0], store.reportCreatedEndDate[0])
    ) {
      return true;
    }

    // Check completed date range validation
    if (
      !disableCompletedDateInputs &&
      hasPartialDateRange(store.reportCompletedStartDate[0], store.reportCompletedEndDate[0])
    ) {
      return true;
    }

    // If only completed dates are enabled, both must be filled
    if (!disableCompletedDateInputs && disableCreatedDateInputs) {
      if (store.reportCompletedStartDate[0] === '' || store.reportCompletedEndDate[0] === '') {
        return true;
      }
    }

    // If both date inputs are enabled, at least one range must be filled
    if (!disableCompletedDateInputs && !disableCreatedDateInputs) {
      const noCreatedDates = store.reportCreatedStartDate[0] === '' && store.reportCreatedEndDate[0] === '';
      const noCompletedDates = store.reportCompletedStartDate[0] === '' && store.reportCompletedEndDate[0] === '';

      if (noCreatedDates && noCompletedDates) {
        return true;
      }
    }

    return false;
  };

  return (
    <div>
      <Container fluid="lg" className=" mt-4 semi-fluid-container" style={{ maxWidth: '800px' }}>
        <h1 className="floating-box-header-newload">
          <div style={{ flexGrow: 1 }}></div>
        </h1>
        <section className="floating-box-newload" style={{ paddingTop: '1.3rem' }}>
          <h1 style={{ color: '#0e2554', fontSize: '1.8rem', marginLeft: '20px' }}>{reportName}</h1>
          <form onSubmit={handleSubmit} id="newload">
            <div>
              <div id="reporting-form" className="mt-2">
                {enableCreated && (
                  <div className="report-inputs-group">
                    <section className="report-section-title">
                      <span className="">Created&nbsp;Date </span>
                    </section>
                    <section className="report-inputs-group-params">
                      <div className="mx-2">
                        <Input
                          label="From"
                          type="date"
                          name="createdstartdate"
                          value={store.reportCreatedStartDate[0]}
                          onChange={(e) => store.reportCreatedStartDate[1](e.target.value)}
                          disabled={disableCreatedDateInputs}
                          reportStyle={true}
                        />
                      </div>
                      <div className="mx-2">
                        <Input
                          label="To"
                          type="date"
                          name="createdenddate"
                          value={store.reportCreatedEndDate[0]}
                          onChange={(e) => store.reportCreatedEndDate[1](e.target.value)}
                          disabled={disableCreatedDateInputs}
                          reportStyle={true}
                        />
                      </div>
                    </section>
                  </div>
                )}

                {enableCompleted && (
                  <div className="report-inputs-group">
                    <section className="report-section-title">
                      <span className="">Completed&nbsp;Date </span>
                    </section>
                    <section className="report-inputs-group-params">
                      <div className="mx-2">
                        <Input
                          label="From"
                          type="date"
                          name="completedstartdate"
                          value={store.reportCompletedStartDate[0]}
                          onChange={(e) => store.reportCompletedStartDate[1](e.target.value)}
                          disabled={disableCompletedDateInputs}
                          reportStyle={true}
                        />
                      </div>
                      <div className="mx-2">
                        <Input
                          label="To"
                          type="date"
                          name="completedenddate"
                          value={store.reportCompletedEndDate[0]}
                          onChange={(e) => store.reportCompletedEndDate[1](e.target.value)}
                          disabled={disableCompletedDateInputs}
                          reportStyle={true}
                        />
                      </div>
                    </section>
                  </div>
                )}
                {enableDeleted && (
                  <div className="report-inputs-group">
                    <section className="report-section-title">
                      <span>Tick to include deleted notes</span>
                    </section>
                    <section className="report-section-title">
                      <div className="mx-2 d-flex align-items-center">
                        <input
                          type="checkbox"
                          onChange={(event) => store.reportViewDeleted[1](event.target.checked)}
                          checked={store.reportViewDeleted[0]}
                        />
                      </div>
                    </section>
                  </div>
                )}
                {customerCall && (
                  <div className="report-inputs-group">
                    <section className="report-section-title">
                      <span className="">{dropdownData}&nbsp;Selection </span>
                    </section>
                    <section className="report-inputs-group-params">
                      <div className="mx-2 w-100">
                        <Select
                          label={`${dropdownData === 'Year' ? 'Year' : `${dropdownData}`}`}
                          name={`${dropdownData === 'Year' ? 'Year' : `${dropdownData}`}`}
                          data={store.reportCustomer[0]}
                          setData={store.reportCustomer[1]}
                          options={store.reportCustomerDropdown[0]}
                          disabled={disableCustInputs}
                          reportStyle={true}
                        />
                      </div>
                    </section>
                  </div>
                )}
              </div>
              <div className="d-flex justify-content-between">
                <button
                  type="button"
                  className="stepper-button"
                  onClick={backToSelection}
                  style={{ marginBottom: '28px', marginLeft: '28px', backgroundColor: '#006c63', color: '#f3f4f6' }}
                >
                  Back
                </button>

                <button
                  className="stepper-button yellow"
                  type="submit"
                  style={{ justifySelf: 'end', marginBottom: '28px', marginRight: '28px' }}
                  disabled={isSubmitDisabled()}
                >
                  Results
                </button>
              </div>
            </div>
          </form>
        </section>
      </Container>
    </div>
  );
}
